import {
  Globe, BookOpen, Mail, Workflow,
  Search, PenTool, Hammer, Rocket, TrendingUp
} from "lucide-react";

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/fdf674c8-d7f7-465b-9db9-5eb5edf09f9a/images/73badb2337b5528c087497c1800315d54ebfb1281fbef7768fdc7670b224df74.jpeg",
  about: "https://static.prod-images.emergentagent.com/jobs/fdf674c8-d7f7-465b-9db9-5eb5edf09f9a/images/364895ab3f8b7ad07e029ae076a6e15fede7c40b1424d42451aa0549b60d0d61.jpeg",
  p1: "/assets/beauty-project.png",
  p2: "/assets/insurance-project.png",
  p3: "/assets/travel-project.png",
  p4: "/assets/service-project.png",
};

export const SERVICES = [
  { icon: Globe, title: "Strony internetowe", desc: "Nowoczesne i estetyczne strony dopasowane do Twojej marki, oferty i klientów." },
  { icon: BookOpen, title: "E-booki i poradniki", desc: "Profesjonalne materiały cyfrowe, które wspierają sprzedaż, edukację klientów i budują ekspercki wizerunek." },
  { icon: Mail, title: "Newslettery i mailing", desc: "Przemyślana komunikacja e-mail, która pomaga utrzymywać kontakt z klientami i rozwijać relacje." },
  { icon: Workflow, title: "Automatyzacja pracy", desc: "Proste rozwiązania, które porządkują procesy, oszczędzają czas i ograniczają ręczne działania." },
];

export const PROCESS = [
  { n: "01", icon: Search, title: "Poznajemy potrzeby", desc: "Rozmawiamy o Twojej firmie, celach, odbiorcach i tym, czego naprawdę potrzebujesz." },
  { n: "02", icon: PenTool, title: "Planujemy rozwiązanie", desc: "Ustalamy zakres, strukturę, funkcje i kierunek wizualny dopasowany do projektu." },
  { n: "03", icon: Hammer, title: "Tworzymy", desc: "Przygotowujemy uzgodnione materiały, stronę, komunikację lub automatyzację." },
  { n: "04", icon: Rocket, title: "Testujemy i dopracowujemy", desc: "Sprawdzamy działanie, poprawiamy szczegóły i przygotowujemy projekt do wdrożenia." },
  { n: "05", icon: TrendingUp, title: "Uruchamiamy i wspieramy", desc: "Wdrażamy gotowe rozwiązanie i w razie potrzeby pomagamy dalej je rozwijać." },
];

export const PORTFOLIO = [
  { img: IMAGES.p1, title: "Projekt dla branży beauty", tag: "Projekt demonstracyjny", desc: "Przykładowa strona z rezerwacją wizyt online i chatbotem odpowiadającym na najczęstsze pytania klientek." },
  { img: IMAGES.p2, title: "Projekt dla biura ubezpieczeń", tag: "Projekt demonstracyjny", desc: "Przykładowa strona z formularzem kontaktowym i automatycznymi wiadomościami e-mail do klientów." },
  { img: IMAGES.p3, title: "Projekt dla biura podróży", tag: "Projekt demonstracyjny", desc: "Przykładowa strona prezentująca oferty wyjazdów z możliwością wysłania zapytania online." },
  { img: IMAGES.p4, title: "Projekt dla firmy usługowej", tag: "Projekt demonstracyjny", desc: "Przykładowa strona z integracją kalendarza i automatycznym potwierdzaniem umówionych spotkań." },
];

export const BENEFITS = [
  "Sprawniejsza obsługa zapytań",
  "Automatyczne odpowiedzi na częste pytania",
  "Prostsze umawianie spotkań",
  "Profesjonalna obecność w internecie",
  "Mniej powtarzalnych czynności",
  "Lepsza organizacja kontaktu z klientami",
];

export const FAQ = [
  { q: "Dla jakich firm tworzycie rozwiązania?", a: "Tworzymy rozwiązania dla małych i średnich firm, które chcą sprawniej obsługiwać klientów i lepiej zaistnieć w internecie - od usług lokalnych po biura i gabinety." },
  { q: "Czym Veliora różni się od zwykłej agencji stron?", a: "Skupiamy się nie tylko na wyglądzie strony, ale też na tym, by realnie ułatwiała prowadzenie firmy - dzięki chatbotom AI i prostym automatyzacjom, które oszczędzają czas." },
  { q: "Ile trwa realizacja projektu?", a: "Termin zależy od zakresu projektu. Prostą stronę możemy przygotować znacznie szybciej niż rozbudowany projekt z integracjami. Dokładny harmonogram ustalamy przed rozpoczęciem współpracy." },
  { q: "Czy oferujecie wsparcie po wdrożeniu?", a: "Tak. Po wdrożeniu możesz skorzystać z dalszej opieki i rozwoju strony lub automatyzacji w modelu miesięcznym." },
  { q: "Jak wygląda wycena?", a: "Każdy projekt wyceniamy indywidualnie po poznaniu jego zakresu. Przed rozpoczęciem współpracy otrzymujesz jasną ofertę i koszt realizacji." },
];
